define(
    ["require", "jquery", "magnificPopup"],
    function (require, jquery) {

        "use strict";

        // requirejs is running into a race condition when requiring scanTranslations in the top-level
        // callback. The resolution seems to be to execute a predefined method within a secondary
        // callback. See comments here:
        // https://stackoverflow.com/questions/16925047/making-requirejs-wait-until-files-have-loaded-before-continuing

        require(
            ["scanTranslations"],
            function (scanTranslations) {
                init(scanTranslations, jquery);
            }
        );

        function init(scanTranslations, $) {
            var $overlay = $('.overlay');

            scanTranslations.getInstance().then(function (scanTranslationInstance) {
                // Default Overlay Options
                // http://dimsemenov.com/plugins/magnific-popup/documentation.html#options
                var defaultOverlayOptions = {
                    alignTop: false,
                    closeBtnInside: true,
                    closeOnBgClick: true,
                    closeOnContentClick: false,
                    closeMarkup: '<button title="%title%" type="button" class="mfp-close" aria-label="' + scanTranslationInstance.translate("close_overlay") + '">&#215;</button>',
                    callbacks: {
                        // Callback events:
                        // http://dimsemenov.com/plugins/magnific-popup/documentation.html#api
                    },
                    disableOn: function() {return true;},
                    enableEscapeKey: true,
                    fixedBgPos: 'auto',
                    fixedContentPos: 'auto',
                    focus: '', // CSS selector of input to focus after popup is opened
                    key: null,
                    mainClass: 'is-animated', // CSS class that is added to popup wrapper and background overlay. See magnific-popup.less to adjust CSS animation.
                    midClick: false,
                    modal: false,
                    overflowY: 'auto',
                    preloader: true,
                    prependTo: null,
                    removalDelay: 400, // Delay in milliseconds before popup is removed
                    showCloseBtn: true,
                    tClose: scanTranslationInstance.translate("overlay_close"),
                    tLoading: scanTranslationInstance.translate("overlay_loading"),
                    type: 'image'
                };

                // Image Overlay Options
                // http://dimsemenov.com/plugins/magnific-popup/documentation.html#image-type
                var imageOverlayOptions = { type: 'image' };

                // Inline Overlay Options
                // http://dimsemenov.com/plugins/magnific-popup/documentation.html#inline-type
                var inlineOverlayOptions = { type: 'inline' };

                // Iframe Overlay Options
                // http://dimsemenov.com/plugins/magnific-popup/documentation.html#iframe-type
                var iframeOverlayOptions = {
                    type: 'iframe',
                    iframe: {
                        markup: '<div class="mfp-iframe-scaler embed-responsive embed-responsive-4by3">' +
                            '<div class="mfp-close"></div>' +
                            '<iframe class="mfp-iframe"></iframe>' +
                            '</div>',

                        patterns: {
                            index: '',
                            src: '%id%'
                        },
                        srcAction: 'iframe_src'
                    }
                };

                // Embed Overlay Options
                // http://dimsemenov.com/plugins/magnific-popup/documentation.html#iframe-type
                var embedOverlayOptions = {
                    type: 'iframe',
                    disableOn: 480, // Width to disable modal and use native app for small devices
                    iframe: {
                        markup: '<div class="mfp-iframe-scaler embed-responsive embed-responsive-16by9">' +
                            '<div class="mfp-close"></div>' +
                            '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                            '</div>',

                        patterns: {
                            html: {
                                index: '',
                                src: '%id%'
                            },
                            youtube: {
                                index: 'youtube.com/',
                                id: 'v=',
                                src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0' // URL that will be set as a source for iframe.
                            },
                            vimeo: {
                                index: 'vimeo.com/',
                                id: '/',
                                src: '//player.vimeo.com/video/%id%?autoplay=1'
                            },
                            gmaps: {
                                index: '//maps.google.',
                                src: '%id%&output=embed'
                            }
                            // you may add here more sources
                        },
                        srcAction: 'iframe_src'
                    }
                };

                // AJAX Overlay Options
                // http://dimsemenov.com/plugins/magnific-popup/documentation.html#ajax-type
                var ajaxOverlayOptions = { type: 'ajax' };

                // Gallery Overlay Options
                // http://dimsemenov.com/plugins/magnific-popup/documentation.html#gallery
                var galleryOverlayOptions = {
                    type: 'image',
                    gallery: {
                        enabled: true, // set to true to enable gallery
                        //delegate: 'img', // the selector for gallery item
                        preload: [0, 2], // read about this option in next Lazy-loading section
                        navigateByImgClick: true,
                        arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button
                        tPrev: scanTranslationInstance.translate("overlay_previous"), // title for left button
                        tNext: scanTranslationInstance.translate("overlay_next"), // title for right button
                        tCounter: '<span class="mfp-counter">' + scanTranslationInstance.translate("overlay_counter") + '</span>' // markup of counter
                    }
                };

                // Leave Registration Overlay Options
                // http://dimsemenov.com/plugins/magnific-popup/documentation.html#inline-type
                var leaveRegistrationOverlayOptions = {
                    type: 'inline',
                    closeBtnInside: false,
                    showCloseBtn: false,
                    disableOn: 0
                };

                // Inline Overlay Options
                // http://dimsemenov.com/plugins/magnific-popup/documentation.html#inline-type
                var helpBlockOverlayOptions = {
                    type: 'inline'
                };

                // Look to see if .overlay is on page...
                if ($('.overlay').length > 0) {
                    // Using $.extend to combine variable options listed above
                    // but include an empty object ({}) to hold the combined object so you don't overwrite the defaultOverlayOptions object

                    // $('.overlay').magnificPopup(defaultOverlayOptions); // everything has an overlay classs.. is this needed????

                    $('.image-overlay').magnificPopup($.extend({}, defaultOverlayOptions, imageOverlayOptions));
                    $('.embed-overlay').magnificPopup($.extend({}, defaultOverlayOptions, embedOverlayOptions));
                    $('.inline-overlay').magnificPopup($.extend({}, defaultOverlayOptions, inlineOverlayOptions));
                    $('.iframe-overlay').magnificPopup($.extend({}, defaultOverlayOptions, iframeOverlayOptions));
                    $('.ajax-overlay').magnificPopup($.extend({}, defaultOverlayOptions, ajaxOverlayOptions));
                    $('.gallery-overlay').magnificPopup($.extend({}, defaultOverlayOptions, galleryOverlayOptions));
                    $('.help-block-overlay').magnificPopup($.extend({}, defaultOverlayOptions, helpBlockOverlayOptions));
                    $('.leave-registration').magnificPopup($.extend({}, defaultOverlayOptions, leaveRegistrationOverlayOptions),
                        $('.close-btn').on("click", function () { $.magnificPopup.close(); })
                    );
                }
            });
        }
    }
);
